import { useEffect, useState } from "react";
import isClient from "../utils/browser/isClient";
var sizes = new Map([["mobile", "(max-width: 767px)"], ["tablet", "(max-width: 1110px)"], ["desktop", "(min-width: 1110px)"]]);
var useMediaQuery = function useMediaQuery(size) {
  var updateMatches = function updateMatches() {
    if (!isClient()) return false;
    var query = sizes.get(size) || "(max-width: " + size + "px)";
    return window.matchMedia(query).matches;
  };
  var _useState = useState(updateMatches),
    matches = _useState[0],
    setMatches = _useState[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      return setMatches(updateMatches);
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return matches;
};
export default useMediaQuery;